// import { fetch } from 'wix-fetch';
import { biLoggerFactory } from 'wix-private'
import wixLocation from 'wix-location'
import { session } from 'wix-storage'
// import moment from 'moment'

const ORIGIN_STORAGE_KEY = 'BI_ORIGIN'

const siteBaseUrl = 'https://www.wix.com/velo'

// let cacheKillerCounter = 0;

// // const getCacheKiller = () => {
// //     return new Date().getTime() + cacheKillerCounter++;
// // };

const defaultParams = {
    page_url: wixLocation.url,
    msid: '5e066938-2bee-49eb-b351-d93a44bca6cc',
    session_id: self.fedops.sessionId
}

export const sendBi = (evid, params) => {
    if (isSiteDuplicate()) return null

    const endPoint = 'platform-cm'
    const src = 83

    const platformBiLogger = biLoggerFactory(endPoint, src, defaultParams)
    const mergedParams = Object.assign({}, params, { evid })

    const logResponse = platformBiLogger.log(mergedParams)

    return logResponse
}

const isSiteDuplicate = () => {
    return wixLocation.baseUrl !== siteBaseUrl
}

export function storeOriginForBI({ origin, url = undefined, ignoreURLValidation = false }) {
    const originDescriptor = JSON.stringify({ url, origin, ignoreURLValidation })
    session.setItem(ORIGIN_STORAGE_KEY, originDescriptor)
}

export function getOriginForBI() {
    const originDescriptor = session.getItem(ORIGIN_STORAGE_KEY)
    removeOriginFromStorage()

    if (originDescriptor) {
        const { origin, url, ignoreURLValidation } = JSON.parse(originDescriptor)

        const isDestination = wixLocation.url === url
        if (isDestination || ignoreURLValidation) {
            return origin
        }
    }
}

export function removeOriginFromStorage() {
    session.removeItem(ORIGIN_STORAGE_KEY)
}

// Generates a random string, used as correlationId for BI purposes 
export function getCorrelationId() {
    const IdLength = 32;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = '';
    for (let i = 0; i < IdLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}